import React from "react";
import "./TermsAndCondition.scss";
import { Link } from "react-router-dom";

const TermsAndCondition = () => {
  return (
    <div>
      <div className="TNC-main">
        <div className="TNC-outer">
          <div className="TNC-part">
            <div className="TNC-inner">
              <p>
                Welcome to RAER a subsidiary of{" "}
                <Link to="/">VIDHYAPRAMAN ENTERPRISE!</Link> By using our
                website, you agree to comply with and be bound by the following
                terms and conditions. Please read them carefully.
              </p>
              <p>
                By accessing or using RAER, you agree to be bound by these terms
                and conditions. If you do not agree with any part of these
                terms, please do not use our website.
              </p>
            </div>
            <div className="TNC-inner">
              <h1>Information We Collect:</h1>
              <p>
                <span>1. Personal Information:</span>
                We collect information such as your name, contact details,
                shipping address, and payment information when you make a
                purchase on our website.
              </p>
              <p>
                <span>2. Account Information:</span>
                When you create an account on RAER, we may collect your
                username, password, and other account-related information.
              </p>
              <p>
                <span>3. Communication: </span>
                We may use your contact details to communicate with you about
                your orders, promotions, and updates related to RAER.
              </p>
              <p>
                <span>4. Website Improvement:</span>
                Browsing data helps us analyze and improve our website, making
                it more user-friendly and efficient.
              </p>
            </div>
            <div className="TNC-inner">
              <h1>Information Security:</h1>
              <p>
                <span>1. Data Encryption: </span>
                We employ industry-standard encryption technologies to secure
                your personal and financial information during transmission.
              </p>
              <p>
                <span> 2. Secure Payment:</span>
                For online transactions, we partner with reputable payment
                gateways to ensure the security of your payment details.
              </p>
            </div>
            <div className="TNC-inner">
              <h1>Disclosure to Third Parties:</h1>
              <p>
                We do not sell, trade, or transfer your personal information to
                outside parties. However, we may share your information with
                trusted third parties involved in order processing, shipping,
                and customer service, with whom we have confidentiality
                agreements.
              </p>
            </div>
            <div className="TNC-inner">
              <h1>Your Choice:</h1>
              <p>You have the right to:</p>
              <p>
                <span>1. Access and Update:</span>
                Access and update your personal information through your RAER
                account settings.
              </p>
              <p>
                <span>2. Opt-Out: </span>
                Opt-out of marketing communications by following the
                instructions provided in our emails or contacting our customer
                support.
              </p>
            </div>
            <div className="TNC-inner">
              <h1>Cookies:</h1>
              <p>
                We use cookies to enhance your browsing experience on our
                website. You can manage cookie preferences through your browser
                settings.
              </p>
            </div>
            <div className="TNC-inner">
              <h1>Updates to Privacy Policy:</h1>
              <p>
                We may update our Privacy Policy to reflect changes in our
                practices. The latest version will be posted on our website.
              </p>
            </div>
            <div className="TNC-inner">
              <h1>Contact Information:</h1>
              <p>
                For any questions or concerns about our Privacy Policy, please
                contact us at [privacy email] or [privacy phone number].
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
